import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuList, MenuItem, MenuItemDivider, MenuItemGroup } from 'components/Menu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export { Menu } from 'components/Menu';
export function AddContentMenuList(_ref) {
  var dispatch = _ref.dispatch,
    targetRankInSection = _ref.targetRankInSection,
    targetParentId = _ref.targetParentId,
    _ref$canAddSection = _ref.canAddSection,
    canAddSection = _ref$canAddSection === void 0 ? false : _ref$canAddSection,
    availableOptions = _ref.availableOptions;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (availableOptions === 'all') {
    return /*#__PURE__*/_jsxs(MenuList, {
      children: [/*#__PURE__*/_jsxs(MenuItemGroup, {
        label: t('content_type_existing'),
        children: [/*#__PURE__*/_jsx(MenuItem, {
          icon: "asset-default",
          onClick: function onClick() {
            return dispatch({
              type: 'REQUEST_NEW_CONTENT',
              variant: 'existing-content',
              targetParentId: targetParentId,
              targetRankInSection: targetRankInSection
            });
          },
          children: t('content_type_asset')
        }), /*#__PURE__*/_jsx(MenuItem, {
          icon: "playlist",
          onClick: function onClick() {
            return dispatch({
              type: 'REQUEST_NEW_CONTENT',
              variant: 'existing-playlist',
              targetParentId: targetParentId,
              targetRankInSection: targetRankInSection
            });
          },
          children: t('content_type_playlist')
        })]
      }), /*#__PURE__*/_jsx(MenuItemDivider, {}), /*#__PURE__*/_jsxs(MenuItemGroup, {
        label: t('content_type_new'),
        children: [/*#__PURE__*/_jsx(MenuItem, {
          icon: "upload",
          onClick: function onClick() {
            return dispatch({
              type: 'REQUEST_NEW_CONTENT',
              variant: 'new-content',
              targetParentId: targetParentId,
              targetRankInSection: targetRankInSection
            });
          },
          children: t('content_type_asset_from_file')
        }), /*#__PURE__*/_jsx(MenuItem, {
          icon: "link",
          onClick: function onClick() {
            return dispatch({
              type: 'REQUEST_NEW_CONTENT',
              variant: 'new-weblink',
              targetParentId: targetParentId,
              targetRankInSection: targetRankInSection
            });
          },
          children: t('file_type_web')
        }), canAddSection && /*#__PURE__*/_jsx(MenuItem, {
          icon: "section",
          onClick: function onClick() {
            return dispatch({
              type: 'REQUEST_NEW_CONTENT',
              variant: 'new-section',
              targetParentId: targetParentId,
              targetRankInSection: targetRankInSection
            });
          },
          children: t('file_type_section')
        })]
      })]
    });
  } else if (availableOptions === 'new-only') {
    return /*#__PURE__*/_jsxs(MenuList, {
      children: [/*#__PURE__*/_jsx(MenuItem, {
        icon: "upload",
        onClick: function onClick() {
          return dispatch({
            type: 'REQUEST_NEW_CONTENT',
            variant: 'new-content',
            targetParentId: targetParentId,
            targetRankInSection: targetRankInSection
          });
        },
        children: t('content_type_asset_from_file')
      }), /*#__PURE__*/_jsx(MenuItem, {
        icon: "link",
        onClick: function onClick() {
          return dispatch({
            type: 'REQUEST_NEW_CONTENT',
            variant: 'new-weblink',
            targetParentId: targetParentId,
            targetRankInSection: targetRankInSection
          });
        },
        children: t('file_type_web')
      })]
    });
  } else if (availableOptions === 'existing-only') {
    return /*#__PURE__*/_jsxs(MenuList, {
      children: [/*#__PURE__*/_jsx(MenuItem, {
        icon: "asset-default",
        onClick: function onClick() {
          return dispatch({
            type: 'REQUEST_NEW_CONTENT',
            variant: 'existing-content',
            targetParentId: targetParentId,
            targetRankInSection: targetRankInSection
          });
        },
        children: t('content_type_asset')
      }), /*#__PURE__*/_jsx(MenuItem, {
        icon: "playlist",
        onClick: function onClick() {
          return dispatch({
            type: 'REQUEST_NEW_CONTENT',
            variant: 'existing-playlist',
            targetParentId: targetParentId,
            targetRankInSection: targetRankInSection
          });
        },
        children: t('content_type_playlist')
      }), canAddSection && /*#__PURE__*/_jsx(MenuItem, {
        icon: "section",
        onClick: function onClick() {
          return dispatch({
            type: 'REQUEST_NEW_CONTENT',
            variant: 'new-section',
            targetParentId: targetParentId,
            targetRankInSection: targetRankInSection
          });
        },
        children: t('file_type_section')
      })]
    });
  }
  return null;
}